import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { PiShoppingBagLight } from "react-icons/pi";
import { FiX } from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { getTotalAmount } from "../../../redux/slice/useCartSlice";
import { RDV_BUTTONS } from "../../../utils/whatsapp";
import FoutaBioLogo from "../../../assets/images/appImages/Logo_Fouta.jpg";

const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/about", label: "À propos" },
  { to: "/accompagnements", label: "Accompagnements" },
  { to: "/produitspage", label: "Produits" },
  { to: "/conseils", label: "Conseils" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const FoutaHeader = () => {
  const dispatch = useAppDispatch();
  const { cartItems } = useAppSelector((state) => state.cart);

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    dispatch(getTotalAmount());
  }, [cartItems, dispatch]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header
      className={`foutabio-header ${scrolled ? "scrolled" : ""} ${
        menuOpen ? "menu-open" : ""
      }`}
    >
      <div className="foutabio-header-inner">
        <NavLink
          to="/"
          className="foutabio-logo"
          onClick={closeMenu}
          aria-label="Retour à l'accueil Fouta Bio"
        >
          <img src={FoutaBioLogo} alt="Fouta Bio" className="fouta-logo" />
        </NavLink>

        <div className="foutabio-header-mobile-actions no-view-desktop">
          <NavLink
            to="/panier"
            className="foutabio-cart-link"
            aria-label="Panier"
            onClick={closeMenu}
          >
            <PiShoppingBagLight size={22} />
            {(cartItems?.length ?? 0) > 0 && (
              <span className="foutabio-cart-badge">{cartItems.length}</span>
            )}
          </NavLink>

          <button
            type="button"
            className="foutabio-burger"
            aria-label={menuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((value) => !value)}
          >
            {menuOpen ? (
              <FiX size={24} />
            ) : (
              <>
                <span />
                <span />
                <span />
              </>
            )}
          </button>
        </div>

        <nav className={`foutabio-nav ${menuOpen ? "open" : ""}`}>
          <button
            type="button"
            className="foutabio-nav-close"
            aria-label="Fermer le menu"
            hidden={!menuOpen}
            onClick={closeMenu}
          >
            <FiX size={28} strokeWidth={2.5} />
          </button>

          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={label}
              to={to}
              end={to === "/"}
              className={({ isActive }) =>
                `foutabio-nav-link${isActive ? " active" : ""}`
              }
              onClick={closeMenu}
            >
              {label}
            </NavLink>
          ))}

          <div className="foutabio-nav-actions no-view-desktop">
            {RDV_BUTTONS.map((rdv) => (
              <a
                key={rdv.country}
                href={rdv.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`foutabio-btn foutabio-btn-rdv foutabio-btn-rdv-${rdv.country.toLowerCase()}`}
                onClick={closeMenu}
              >
                {rdv.label}
              </a>
            ))}
          </div>
        </nav>

        <div className="foutabio-header-actions no-view-mobile">
          {RDV_BUTTONS.map((rdv) => (
            <a
              key={rdv.country}
              href={rdv.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`foutabio-btn foutabio-btn-rdv foutabio-btn-rdv-${rdv.country.toLowerCase()}`}
            >
              {rdv.label}
            </a>
          ))}

          <NavLink to="/panier" className="foutabio-cart-link" aria-label="Panier">
            <PiShoppingBagLight size={22} />
            {(cartItems?.length ?? 0) > 0 && (
              <span className="foutabio-cart-badge">{cartItems.length}</span>
            )}
          </NavLink>
        </div>
      </div>

      <div className="foutabio-mobile-fixed-cta no-view-desktop">
        {RDV_BUTTONS.map((rdv) => (
          <a
            key={rdv.country}
            href={rdv.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`foutabio-btn foutabio-btn-rdv foutabio-btn-rdv-${rdv.country.toLowerCase()}`}
            onClick={closeMenu}
          >
            {rdv.label}
          </a>
        ))}
      </div>
    </header>
  );
};

export default FoutaHeader;
